import { useEffect } from 'react';
import { Subject, fromEvent, merge, interval } from 'rxjs';
import { throttle } from 'rxjs/operators';
import { refreshSession } from 'api/user/service';

export const extendSession$ = new Subject();

let refresh;

extendSession$.subscribe({
  next: ({ history, logout, setExtendSession }) => {
    refresh = refreshSession().subscribe((data) => {
      if (!data.success) return logout({ history });
      setExtendSession(Date.now());
    });
  }
});

const useExtendSessionOnInteraction = ({
  history,
  isExpirationWindowOpened,
  logout,
  setExtendSession
}) => {
  useEffect(() => () => refresh?.unsubscribe(), []);

  useEffect(() => {
    const allEvents$ = merge(
      fromEvent(window.document, 'click'),
      fromEvent(window.document, 'keyup')
    ).pipe(throttle(() => interval(10000)));
    const subscriber = allEvents$.subscribe(() => {
      if (!isExpirationWindowOpened) {
        extendSession$.next({ logout, setExtendSession, history });
      }
    });
    return () => {
      subscriber.unsubscribe();
      refresh?.unsubscribe();
    };
  }, [isExpirationWindowOpened, logout, setExtendSession]);
};

export default useExtendSessionOnInteraction;
